import React, {Component} from 'react'
import QuestionForm from './QuestionForm'
import {questionsByCategorySortedSelector} from '../../../modules/questions'
import {createSelector} from 'reselect'
import {connect} from 'react-redux'
import {List, WindowScroller, AutoSizer, CellMeasurer, CellMeasurerCache} from 'react-virtualized'
import {throttle} from './../../../helpers/common'


class Questions extends Component {

    state = {
        rowRefs : {},
    }

    render() {
        const {questions} = this.props
        if (!questions.length) return null

        return (
            <WindowScroller>
                {({height, isScrolling, onChildScroll, scrollTop}) => (
                    <AutoSizer disableHeight>
                        {({width}) => (
                            <List
                                isScrolling={isScrolling}
                                onScroll={onChildScroll}
                                scrollTop={scrollTop}
                                rowRenderer = {this.rowRenderer}
                                autoHeight
                                height = {height}
                                rowCount = {questions.length}
                                rowHeight={this._cache.rowHeight}
                                width = {width}
                                overscanRowCount={0}
                                ref = {this.getListRef}
                                deferredMeasurementCache = {this._cache}
                            />
                        )}
                    </AutoSizer>
                )}
            </WindowScroller>
        )

        return questions
                    .map(({id}) => {
                        return (
                            <QuestionForm
                                key = {id}
                                questionId = {id}
                            />
                        )
                    })
    }

    rowRenderer = (props) => {
        let {key, parent, index, style} = props
        let {questions} = this.props
        let question = questions[index]
        let {id} = question

        return (
            <CellMeasurer
                cache={this._cache}
                columnIndex={0}
                key={key}
                parent={parent}
                rowIndex={index}
            >
                {({measure}) => (
                    <QuestionForm
                        ref = {this.getRowRef(index)}
                        questionId = {id}
                        style = {style}
                        measure = {this.handleMeasurement({index, measure})}
                        massMeasurer = {this.handleMassMeasurement}
                    />
                )}
            </CellMeasurer>
        )
    }

    handleMeasurement = (params) => () => {
        let {index, measure} = params
        this._cache.clear(index)
        measure()
        this.listRef && this.listRef.recomputeRowHeights(index)
    }

    handleMassMeasurement = () => {
        this._cache.clearAll()
        this.listRef && this.listRef.recomputeRowHeights()
    }

    getListRef = ref => {
        window.__listRef =this.listRef = ref
    }

    getRowRef = (index) => (rowRef) => {
        if (rowRef && !this.state.rowRefs[index]) {
            this.setState((prevState) => ({
                rowRefs : {
                    ...prevState.rowRefs,
                    [index] : 1,
                }
            }), this._cache.clearAll)
        }
    }

    _measure = () => {
        this._cache.clearAll()
        this.listRef && this.listRef.recomputeRowHeights()
    }

    _cache = new CellMeasurerCache({
        fixedWidth : true,
        minHeight : Questions.DEFAULT_ROW_HEIGHT,
    })

    componentDidMount() {
        window.addEventListener('resize', this._throttledMeasure)
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this._throttledMeasure)
    }

    _throttledMeasure = throttle(this._measure, 100)

    static DEFAULT_ROW_HEIGHT = 480 // 877
}

export default connect(
    state => ({
        questions : questionsByCategorySortedSelector(state)
    })
)(Questions)


// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/QbmPage/QbmBody/Questions.js